import { Directive } from '@angular/core';

@Directive({
  selector: '[crmPageActions], crm-page-actions',

})
export class PageActionsDirective {}
